<ng-container *ngIf="viewModel$ | async as vm">
  <div class="container-fluid p-0 d-flex flex-column flex-grow-1">
    <div class="row no-gutters flex-grow-1">
      <div class="col-12">
        <form [formGroup]="formGroup">
          <div class="form-row">
            <div class="col-6">
              <label for="notes">Call Notes</label>
              <textarea class="form-control" formControlName="notes" rows="4"></textarea>
            </div>
            <div class="col-6">
              <label for="notes">Client Notes</label>
              <textarea class="form-control" formControlName="clientNotes" rows="4"></textarea>
            </div>
          </div>
        </form>
        <div class="form-row">
          <table class="table table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">Campaign</th>
                <th scope="col">Attempt</th>
                <th scope="col">Date & Time</th>
                <th scope="col">Outcome</th>
                <th scope="col">Complete</th>
                <th scope="col">User</th>
                <th scope="col">Notes</th>
                <th scope="col">Client</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="vm.currentaction !== undefined">
                <td class="text-nowrap">{{ vm.currentaction.campaignId }}</td>
                <td class="text-nowrap">{{ vm.attempt }}</td>
                <td class="text-nowrap">Current Call</td>
                <td class="text-nowrap">{{ vm.currentaction.outcome }}</td>
                <td class="text-nowrap">
                  {{ vm.currentaction.completed ? "Yes" : "No" }}
                </td>
                <td class="text-nowrap">
                  {{ vm.currentuser | userName | async }}
                </td>
                <td>
                  <div class="notes text-truncate cursor-pointer"
                    (click)="showNote(noteModal, vm.currentaction.notes!)">
                    {{ vm.currentaction.notes }}
                  </div>
                </td>
                <td>
                  <div class="notes text-truncate cursor-pointer"
                    (click)="showNote(noteModal, vm.currentaction.clientNotes!)">
                    {{ vm.currentaction.clientNotes }}
                  </div>
                </td>
              </tr>
              <tr *ngFor="
                  let a of vm.actions
                    | orderBy: { field: 'datetime', order: 'desc' }
                ">
                <td class="text-nowrap">{{ a.campaignId }}</td>
                <td class="text-nowrap">{{ a.attempt }}</td>
                <td class="text-nowrap">
                  {{ a.datetime | date: "dd/MM/YYYY HH:mm" }}
                </td>
                <td class="text-nowrap">{{ a.outcome }}</td>
                <td class="text-nowrap">{{ a.completed ? "Yes" : "No" }}</td>
                <td class="text-nowrap">{{ a.userId | userName | async }}</td>
                <td>
                  <div class="notes text-truncate cursor-pointer" (click)="showNote(noteModal, a.notes)">
                    {{ a.notes }}
                  </div>
                </td>
                <td>
                  <div class="notes text-truncate cursor-pointer" (click)="showNote(noteModal, a.clientNotes)">
                    {{ a.clientNotes }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row no-gutters" style="position: fixed; bottom: 19px">
      <div class="col-auto">
        <ng-container *ngIf="vm.ibLaunched || (vm.ib && !vm.obLaunched); else obButtons">
          <button [disabled]="vm.testMode || vm.closeDisable || vm.submitting" type="button"
            class="btn btn-secondary w-16-25rem" (click)="closeIB()">Close</button>
        </ng-container>
        <ng-template #obButtons>
          <button [disabled]="vm.testMode || vm.closeDisable || vm.submitting" type="button"
            class="btn btn-secondary w-8rem" (click)="closeOB()">Close</button>
          <button [disabled]="!vm.obLaunched || vm.submitting" type="button" class="btn btn-secondary w-8rem ml-1"
            (click)="next()">Next</button>
        </ng-template>

      </div>
    </div>
  </div>
  <ng-template #noteModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Note</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <textarea class="form-control h-100" readonly>{{ vm.note }}</textarea>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">
        Close
      </button>
    </div>
  </ng-template>
</ng-container>